import { BrowserRouter, Switch, Route } from "react-router-dom";
import About from "./Pages/AboutPage/About.page"
// import Contact from "./Pages/ContactPage/Contact.page"
import Event from "./Pages/EventPage/Event.page"
import Project from "./Pages/ProjectPage/Project.page"
import Team from "./Pages/TeamPage/Team.page";
import Vision from "./Pages/VisionPage/Vision.page";
import Overview from "./Pages/OverviewPage/Overview.page";
import HomePage from "./Pages/HomePage/Home";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path='/aboutus' exact component={About} />
        <Route path='/our-team' exact component={Team} />
        <Route path='/projects' exact component={Project} />
        <Route path='/events' exact component={Event} />
        <Route path='/our-vision' exact component={Vision} />
        <Route path='/explore-more' exact component={Overview} />
        <Route path='/' exact component={HomePage} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
